import { Component, Inject } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-number-filter-dialog',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
  ],
  templateUrl: './number-filter-dialog.component.html',
  styleUrl: './number-filter-dialog.component.scss',
})
export class NumberFilterDialogComponent {
  form: FormGroup;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      label: string;
      value: number | null;
      step: number;
      min_value?: number;
      max_value?: number;
      suffix?: string;
      prefix?: string;
    },
    private dialogRef: MatDialogRef<NumberFilterDialogComponent>,
    private fb: FormBuilder
  ) {
    this.form = this.fb.group({
      value: [this.data.value ?? null, [Validators.min(this.data.min_value ?? 0), Validators.max(this.data.max_value ?? Infinity)]],
    });
  }

  save(): void {
    if (this.form.invalid) {
      return;
    }

    this.dialogRef.close(this.form.get('value')?.value);
  }

  clear(): void {
    this.dialogRef.close(null);
  }

  cancel(): void {
    this.dialogRef.close();
  }
}